import type { MealType } from "../domain/model.js";

const mealPatterns: ReadonlyArray<[MealType, RegExp]> = [
  ["breakfast", /(?<!\p{L})завтрак(?:а|ом|е|у)?(?!\p{L})/iu],
  ["lunch", /(?<!\p{L})обед(?:а|ом|е|у)?(?!\p{L})/iu],
  ["dinner", /(?<!\p{L})ужин(?:а|ом|е|у)?(?!\p{L})/iu],
  ["snack", /(?<!\p{L})перекус(?:а|ом|е|у)?(?!\p{L})/iu],
];

export const mealTypeLabels: Record<MealType, string> = {
  breakfast: "Завтрак",
  lunch: "Обед",
  dinner: "Ужин",
  snack: "Перекус",
};

export function detectMealType(transcript: string): MealType | null {
  return mealPatterns.find(([, pattern]) => pattern.test(transcript))?.[0] ?? null;
}
